import Restriction, { type IRestrictionProps } from "./Restriction";

interface IAmenityProps {
  restriction: IRestrictionProps;
}

const Amenity = ({ restriction }: IAmenityProps) => {
  return (
    <Restriction
      symbol={restriction.symbol}
      description={restriction.description}
      category={restriction.category}
    />
  );
};

export default Amenity;
